export const START_APP_YEAR = 2022;
export const GROUPS_KEY = {
  month: 'month',
  year: 'year',
  day: 'day',
  special: 'special',
};
